<mat-toolbar>
  <mat-toolbar-row class="d-flex justify-content-between">
    <h1 id="main_title" class="uk-text-subheading" [innerHTML]="title"></h1>
    <div class="content-version" *ngIf="version">
      <span class="version">v.{{ version }}</span>
    </div>
    <div class="nav-info-user d-flex align-items-center px-1">
      <div class="d-flex flex-column" *ngIf="!isMobile">
        <span id="user_name" class="uk-text-title">
          {{ (user$ | async)?.name | uppercase }}
        </span>
        <small id="company_name">{{
          store ? (store.entityName | uppercase) || (store.name | uppercase) : ""
        }}</small>
      </div>
      <div id="company_logo" [class]="company"></div>
      <mat-icon
        style="padding-right: 5px"
        svgIcon="user"
        class="logout"
        matTooltip="Usuario"
        [matMenuTriggerFor]="menu"
      ></mat-icon>
      <mat-menu #menu="matMenu">
        <div class="d-flex flex-column column justify-content-center align-items-center" *ngIf="isMobile">
          <span id="user_name" class="uk-text-title">
            {{ (user$ | async)?.name | uppercase }}
          </span>
          <small id="company_name"><b>
            {{store ? (store.entityName | uppercase ) || (store.name | uppercase)  : "" }}
          </b></small>
        </div>
        <button *ngFor="let item of menuModule" mat-menu-item (click)="redirect(item.id)">
          <span>{{item.text}}</span>
        </button>

        <button mat-menu-item [matMenuTriggerFor]="vertebrates" *ngIf="showMenuChangeUser">Cambiar de usuario</button>

        <mat-menu #vertebrates="matMenu">
          <button mat-menu-item *ngFor="let item of menuChangeUser" (click)="changeUserMenu(item)">{{ item }}</button>
        </mat-menu>

        <mat-divider> </mat-divider>
        <button mat-menu-item (click)="logout()">
          <span>Cerrar sesión</span>
        </button>
      </mat-menu>
    </div>
  </mat-toolbar-row>


</mat-toolbar>
